import { Icon } from "@iconify/react";
import {
  Box,
  ButtonBase,
  FormControlLabel,
  Grid,
  IconButton,
  Table as MuiTable,
  Radio,
  Stack,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery
} from "@mui/material";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import AppDialog from "../../components/Common/AppDialog";
import DeleteModal from "../../components/Common/DeleteModal";
import LoadingDialog from "../../components/Common/LoadingDialog";
import Notification from "../../components/Common/Notification";
import PopOverFilter from "../../components/Common/PopoverFilter";
import SearchBar from "../../components/Common/Searchbar";
import Table from "../../components/Common/Table";
import TablePageControl from "../../components/Common/TablePageControl";
import CheckBox from "../../components/Form/CheckBox";
import CustomButton from "../../components/Form/CustomButton";
import CustomTextField from "../../components/Form/CustomTextField";
import CustomizedDatePicker from "../../components/Form/DatePicker";
import Helpers from "../../helpers/helpers";
import { deleteQuotation as deleteQuotationAction, getQuotationDetails, getQuotationFilters, getQuotationListing, resetQuotationActionState, sendQuotationEmail, sendQuotationWhatsapp } from "../../store/actions";
import EditQuotation from "./Form/EditQuotation";
import QuotationDetailsDialog from "./QuotationDetailsDialog";


const money = (value) =>
  `$${Number(value).toLocaleString("en-SG", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

const normaliseFilterOptions = (options) => (options || []).map((option) => ({
  ...option,
  label: option?.label ?? option?.name,
  value: option?.value ?? option?.id,
}));

const quotationDatePickerSx = {
  height: "36px",
  marginTop: "-5px",
  padding: "0 12px 0 20px",
  justifyContent: "center",
  border: "1px solid #c4c4c4",
  borderRadius: "20px",
  backgroundColor: "#FFFFFF",
  "&:focus-within": {
    borderColor: "#D9D9D9",
  },
  "& .MuiInputBase-root": {
    minHeight: "36px",
  },
  "& .MuiInputBase-input": {
    padding: "8px 0",
    fontSize: 14,
    "&::placeholder": {
      color: "#BDBDBD",
      opacity: 1,
    },
  },
  "& .MuiIconButton-root": {
    color: "#7D7D7D",
  },
};

const vehicleStatusList = [
  { label: 'New', value: 'new', color: '#2C7F41' },
  { label: 'Used', value: 'used', color: '#FF8D28' },
  { label: 'Rental', value: 'rental', color: '#475A99' },
]

const Quotations = ({ quotation, quotationFilters, quotationDetails, quotationDeleteResponse, quotationEmail, quotationWhatsapp, quotationError, makeList, modelList, advertListing, leftSideBarType, quotationInd, isDirectSeller }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery("(max-width:768px)");
  const [search, setSearch] = useState("");
  const [sort, setSorted] = useState("desc");
  const [sort_by, setSortBy] = useState("created_at");
  const [loanTerm, setLoanTerm] = useState("all");
  const [page, setPage] = useState(1);
  const [length, setLength] = useState(10);
  const [filterOpen, setFilterOpen] = useState(false);
  const emptyFilters = {
    bike_make_ids: [],
    bike_model_ids: [],
    selling_price_min: "",
    selling_price_max: "",
    user_id: "",
    created_date_from: "",
    created_date_to: "",
    vehicle_type: [],
  };
  const [filterObject, setFilterObject] = useState(emptyFilters);
  const [selectedQuotation, setSelectedQuotation] = useState(null);
  const [sendingId, setSendingId] = useState(null);
  const [sendDetailsLoading, setSendDetailsLoading] = useState(false);
  const [detailsQuotation, setDetailsQuotation] = useState(null);
  const [deleteQuotation, setDeleteQuotation] = useState(null);
  const [pdfContent, setPdfContent] = useState("summary");
  const [recipientEmail, setRecipientEmail] = useState("");
  const [sendMySelfCopy, setSendMySelfCopy] = useState(true);
  const [sendMethod, setSendMethod] = useState("email");
  const [editOpen, setEditOpen] = useState(false);
  const [editQuotation, setEditQuotation] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [sendLoading, setSendLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [notification, setNotification] = useState({});
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const searchRef = useRef(search);
  const whatsappShareWindowRef = useRef(null);

  useEffect(() => {
    if (!location.state?.quotationNotification) return;

    setNotification(location.state.quotationNotification);
    navigate(location.pathname, { replace: true, state: null });
  }, [location.pathname, location.state, navigate]);

  useEffect(() => {
    dispatch(getQuotationFilters());
  }, [dispatch]);

  useEffect(() => {
    if (isDirectSeller)
      navigate("/not-found")
  }, [])

  useEffect(() => {
    searchRef.current = search || "";
  }, [search]);

  const handleSearch = (text) => {
    setSearch(text);
    setTimeout(() => {
      if (text === searchRef.current) {
        setPage(page === 1 ? '1' : 1);
      }
    }, Helpers.searchInterval);
  }

  useEffect(() => {
    initData();
  }, [length, page, loanTerm]);

  useEffect(() => {
    if (quotationInd?.code === "success") {
      setIsLoading(false);
    } else if (quotationInd?.code && quotationInd?.code !== "success") {
      setIsLoading(false);
    }
  }, [quotationInd]);

  useEffect(() => {
    if (detailsQuotation && quotationDetails?.code === "success") {
      setDetailsQuotation(quotationDetails?.data);
    }
    if (sendingId && quotationDetails?.code === "success" && quotationDetails?.data?.id === sendingId) {
      setSelectedQuotation(quotationDetails?.data);
      setRecipientEmail(quotationDetails?.data?.customer_email || "");

      setSendDetailsLoading(false);
    }
  }, [quotationDetails]);

  useEffect(() => {
    const response = sendMethod === "email" ? quotationEmail : quotationWhatsapp;
    if (!sendLoading || !response?.code) return;

    if (response.code === "success") {
      if (sendMethod === "whatsapp") {
        const shareUrl = response?.data?.share_url || response?.share_url;

        if (shareUrl) {
          if (whatsappShareWindowRef.current && !whatsappShareWindowRef.current.closed) {
            whatsappShareWindowRef.current.location.replace(shareUrl);
          } else {
            window.open(shareUrl, "_blank", "noopener,noreferrer");
          }
        } else if (whatsappShareWindowRef.current && !whatsappShareWindowRef.current.closed) {
          whatsappShareWindowRef.current.close();
        }
      } else {
        setNotification({
          open: true,
          type: "success",
          msg: response?.message || "Quotation sent via email successfully.",
        });
      }

      whatsappShareWindowRef.current = null;
      setSelectedQuotation(null);
      setSendingId(null);
      setSendLoading(false);
      dispatch(resetQuotationActionState());
    }
  }, [quotationEmail, quotationWhatsapp, sendLoading, sendMethod, dispatch]);

  useEffect(() => {
    if (!sendLoading || !quotationError || (Array.isArray(quotationError) && quotationError.length === 0)) return;

    if (whatsappShareWindowRef.current && !whatsappShareWindowRef.current.closed) {
      whatsappShareWindowRef.current.close();
    }
    whatsappShareWindowRef.current = null;

    setNotification({
      open: true,
      type: "error",
      msg: quotationError?.message || "Unable to send quotation. Please try again.",
    });
    setSendLoading(false);
  }, [quotationError, sendLoading]);

  useEffect(() => {
    if (!deleteLoading || !quotationDeleteResponse?.code) return;

    if (quotationDeleteResponse.code === "success") {
      setNotification({
        open: true,
        type: "success",
        msg: quotationDeleteResponse?.message || "Quotation deleted successfully.",
      });
      setDeleteQuotation(null);
      setDeleteLoading(false);
      dispatch(resetQuotationActionState());
      initData();
    }
  }, [quotationDeleteResponse, deleteLoading]);

  useEffect(() => {
    if (!deleteLoading || !quotationError || (Array.isArray(quotationError) && quotationError.length === 0)) return;

    setNotification({
      open: true,
      type: "error",
      msg: quotationError?.message || "Unable to delete quotation. Please try again.",
    });
    setDeleteLoading(false);
  }, [quotationError, deleteLoading]);

  const initData = (filters = filterObject, requestedPage = page, requestedLoanTerm = loanTerm) => {
    setIsLoading(true);
    dispatch(
      getQuotationListing({
        page: requestedPage,
        length,
        search: searchRef.current,
        loan_term: requestedLoanTerm === "all" ? "" : requestedLoanTerm,
        bike_make_ids: filters?.bike_make_ids || [],
        bike_model_ids: filters?.bike_model_ids || [],
        selling_price_min: filters?.selling_price_min || "",
        selling_price_max: filters?.selling_price_max || "",
        user_id: filters?.user_id || "",
        created_date_from: filters?.created_date_from || "",
        created_date_to: filters?.created_date_to || "",
        vehicle_type: filters?.vehicle_type || [],
        sort: sort,
        sort_by: sort_by,
        tab: "all"
      }),
    );
  };

  const applyFilters = (filters, requestedLoanTerm = loanTerm) => {
    if (page === 1) {
      initData(filters, 1, requestedLoanTerm);
      return;
    }
    setPage(1);
  };

  const handleCreatedDateFilterChange = (field, value) => {
    const formattedDate = value && moment(value).isValid()
      ? moment(value).format("YYYY-MM-DD")
      : "";
    const nextFilters = { ...filterObject, [field]: formattedDate };

    if (field === "created_date_from") setStartDate(value || "");
    if (field === "created_date_to") setEndDate(value || "");
    setFilterObject(nextFilters);
    applyFilters(nextFilters);
  };

  const openQuotationDetails = (item) => {
    setDetailsQuotation(item);
    dispatch(getQuotationDetails({ id: item.id }));
  };

  const openSendDialog = (item, method) => {
    dispatch(resetQuotationActionState());
    setSelectedQuotation(item);
    setSendingId(item.id);
    setSendDetailsLoading(true);
    setSendMethod(method);
    setPdfContent("summary");
    setRecipientEmail("");
    dispatch(getQuotationDetails({ id: item.id }));
  };

  const handleSendQuotation = () => {
    if (!selectedQuotation?.id || sendDetailsLoading || sendLoading) return;

    const data = { content_type: pdfContent };
    setSendLoading(true);

    if (sendMethod === "email") {
      dispatch(sendQuotationEmail({
        id: selectedQuotation.id,
        data: { ...data, email: recipientEmail.trim(), send_myself_copy: sendMySelfCopy },
      }));
      return;
    }

    whatsappShareWindowRef.current = window.open("", "_blank");
    if (whatsappShareWindowRef.current) {
      whatsappShareWindowRef.current.opener = null;
    }

    dispatch(sendQuotationWhatsapp({
      id: selectedQuotation.id,
      data: { ...data, phone: selectedQuotation?.customer_phone?.replace(/^\+/, ""), },
    }));
  };

  const handleDeleteQuotation = () => {
    if (!deleteQuotation?.id || deleteLoading) return;

    dispatch(resetQuotationActionState());
    setDeleteLoading(true);
    dispatch(deleteQuotationAction({ id: deleteQuotation.id }));
  };

  const recipientEmailError = quotationError?.code === "invalid_field"
    ? quotationError?.errors?.email
    : null;
  const recipientEmailErrorMessage = Array.isArray(recipientEmailError)
    ? recipientEmailError[0]
    : recipientEmailError;

  const sendPricing = selectedQuotation?.pricing || {};
  const instalmentPreview = Array.isArray(sendPricing.instalment_schedule) ? sendPricing.instalment_schedule : [];

  const filterData = [
    {
      label: "Make",
      type: "checkbox",
      value: filterObject?.bike_make_ids || [],
      data: normaliseFilterOptions(quotationFilters?.bike_makes),
      xsGrid: 12,
      mdGrid: 12,
      onChange: (e, item) => {
        setFilterObject((prevValues) => ({
          ...prevValues,
          bike_make_ids: e,
        }))
      }
    },
    {
      label: "Model",
      type: "checkbox",
      value: filterObject?.bike_model_ids || [],
      data: normaliseFilterOptions(quotationFilters?.bike_models),
      xsGrid: 12,
      mdGrid: 12,
      onChange: (e, item) => {
        setFilterObject((prevValues) => ({
          ...prevValues,
          bike_model_ids: e,
        }))
      }
    },
    {
      label: "Selling Price",
      type: "priceRange",
      // defaultMax: filterObject?.price_ranges?.selling_price?.max,
      minValue: filterObject?.selling_price_min || "",
      maxValue: filterObject?.selling_price_max || "",
      prefix: "$",
      setMinAmount: (value) => {
        setFilterObject({ ...filterObject, selling_price_min: value })
      },
      setMaxAmount: (value) => {
        setFilterObject({ ...filterObject, selling_price_max: value })
      },
    },
    {
      label: "Creator",
      type: "select",
      value: filterObject?.user_id || "",
      data: quotationFilters?.creators || [],
      valueName: "id",
      labelName: "name",
      xsGrid: 12,
      mdGrid: 12,
      onChange: (e, item) => {
        setFilterObject((prevValues) => ({
          ...prevValues,
          user_id: e,
        }))
      }
    },
    {
      label: "Created Date",
      value: [filterObject?.created_date_from, filterObject?.created_date_to],
      type: "date_range",
      startPlaceholder: "From",
      endPlaceholder: "To",
      startDateTitle: "From",
      startDate: startDate,
      setStartDate: (date) => {
        setStartDate(date);
        const formattedDate = date ? moment(date).format('YYYY-MM-DD') : "";
        setFilterObject((prev) => ({ ...prev, created_date_from: formattedDate }));
      },
      endDateTitle: "To",
      endDate: endDate,
      setEndDate: (date) => {
        setEndDate(date);
        const formattedDate = date ? moment(date).format('YYYY-MM-DD') : "";
        setFilterObject((prev) => ({ ...prev, created_date_to: formattedDate }));
      },
      xsGrid: 12, smGrid: 12, mdGrid: 12
    },
    {
      label: "Vehicle Type",
      type: "checkbox",
      value: filterObject?.vehicle_type || [],
      data: normaliseFilterOptions(quotationFilters?.vehicle_types),
      xsGrid: 12,
      mdGrid: 12,
      onChange: (e, item) => {
        setFilterObject((prevValues) => ({
          ...prevValues,
          vehicle_type: e,
        }))
      }
    },
  ];

  const resetFilters = () => {
    setSearch("");
    searchRef.current = "";
    setLoanTerm("all");
    setStartDate("");
    setEndDate("");
    setFilterObject(emptyFilters);
    setFilterOpen(false);
    applyFilters(emptyFilters, "all");

  };

  const actionButtons = (quotation) => (
    <Stack direction="row" spacing={0.25} onClick={(event) => event.stopPropagation()}>
      <IconButton
        size="medium"
        style={{ color: "#25D366" }}
        aria-label={`Contact ${quotation.customer_name} on WhatsApp`}
        onClick={() => openSendDialog(quotation, "whatsapp")}
      >
        <Icon icon="ri:whatsapp-line" width={22} />
      </IconButton>
      <IconButton
        size="medium"
        aria-label={`Send quotation to ${quotation.customer_name}`}
        onClick={() => openSendDialog(quotation, "email")}
      >
        <Icon icon="ri-mail-line" width={22} />
      </IconButton>
    </Stack>
  );

  const headers = [
    {
      id: "customer",
      Header: "Customer",
      minWidth: 185,
      accessor: (item) => (
        <Box>
          <Typography fontSize={14} fontWeight={500} color="#071A3A">
            {item.customer_name}
          </Typography>
          <Typography fontSize={14} color="#8B9094">
            {item.customer_phone}
          </Typography>
        </Box>
      ),
    },
    {
      id: "vehicle",
      Header: "Vehicle",
      minWidth: 210,
      accessor: (item) => {
        const statusObj = vehicleStatusList.find(vehicle => vehicle.value === item?.bike_advert_type);
        return (
          <Box>
            <Typography fontSize={14} fontWeight={500} color="#071A3A">
              {item.vehicle}
            </Typography>
            <Typography component="div" fontSize={14} color="#8B9094">
              {item.register_number} {item.bike_advert_type ? "•" : ""}{" "}
              <Box component="span" color={statusObj?.color} fontWeight={500}>
                {item.bike_advert_type ? item.bike_advert_type.charAt(0).toUpperCase() + item.bike_advert_type.slice(1) : ""}
              </Box>
            </Typography>
          </Box>
        )
      },
    },
    {
      id: "Selling Price",
      Header: "Selling Price",
      minWidth: 135,
      accessor: (item) => money(item.total_price ?? null) ?? "-",
    },
    {
      id: "Loan Amount",
      Header: "Loan Amount",
      minWidth: 135,
      accessor: (item) => money(item.loan_amount ?? null) ?? "-",
    },
    {
      id: "monthlyTerm",
      Header: "Monthly / Term",
      minWidth: 180,
      accessor: (item) => (
        <Box>
          <Typography fontSize={14} fontWeight={600} color="#252525">
            {money(item.monthly_instalment)}
            <Box component="span" fontSize={14} fontWeight={400} color="#8B9094">
              /mth
            </Box>
          </Typography>
          <Typography fontSize={14}>
            {item.loan_term} months - {Number(item.interest_rate)?.toFixed(2)}%
          </Typography>
        </Box>
      ),
    },
    {
      id: "remarks",
      Header: "Remarks",
      minWidth: 225,
      accessor: (item) => (
        <Typography
          fontSize={14}
          title={item.remarks}
        >
          {item.remarks}
        </Typography>
      ),
    },
    {
      id: "createdby",
      Header: "Created by",
      minWidth: 135,
      accessor: (item) => (
        <Stack spacing={0.25}>
          <Typography fontSize={14} fontWeight={500} color="#071A3A">
            {item.creator_name || "-"}
          </Typography>
          <Typography fontSize={14} color="#8B9094">
            {item.created_at ? moment(item.created_at, "YYYY-MM-DD HH:mm:ss").format("DD MMM YYYY, hh:mm A") : "-"}
          </Typography>
        </Stack>
      ),
    },
    {
      id: "action",
      Header: "Action",
      minWidth: 90,
      accessor: actionButtons,
    },
  ];

  const moreFilters = () => {
    return (
      <>
        <Grid item xs={7} md={2} >
          <PopOverFilter
            setDialogOpen={setFilterOpen}
            open={filterOpen}
            applyFilter={() => {
              setFilterOpen(false);
              applyFilters(filterObject);
            }}
            filterData={filterData}
            setFilterObject={setFilterObject}
            handleResetFilter={resetFilters}
          />
        </Grid>
        {!isMobile && <Grid item xs={5} md={2} >
          <CustomButton
            title={<span style={{ textDecoration: "underline" }}>Clear all</span>}
            press={resetFilters}
            height={34}
            padding={0}
            paddingInline={0}
            backgroundColor="transparent"
            textColor="#B48A3C"
            borderStyle="none"
            fontSize={14}
          />
        </Grid>}
      </>
    )
  }

  return (
    <div className="page-content">
      <LoadingDialog open={isLoading} />
      <Container fluid>
        <Box
          sx={{
            minHeight: "calc(100vh - 150px)",
            display: "flex",
            flexDirection: "column",
            px: { xs: 0, sm: 1 },
          }}
        >
          <Box sx={{ display: isMobile ? "none" : "block" }}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              mb={3.5}
            >
              <Stack direction="row" spacing={1.25} alignItems="center">
                <Typography fontSize={22} fontWeight={600} color="#252525">
                  Quotations
                </Typography>
                <Typography fontSize={18} fontWeight={600} color="#B9C0C6">
                  {quotation?.total || 0}
                </Typography>
              </Stack>

              <CustomButton
                title="Create new quotation"
                press={() => navigate("/quotations/create")}
                height={42}
                paddingInline={24}
                fontSize={14}
              />

            </Stack>
          </Box>
          <Grid container spacing={1.25} alignItems="center" mb={2.5}>
            <Grid item xs={12} md={4}>
              <SearchBar
                value={search}
                setValue={(value) => {
                  handleSearch(value);
                }}
                module="customer, vehicle"
              />
            </Grid>
            {!isMobile && <>
              <Grid item xs={5} md={4}>
                <div className="d-flex align-items-center gap-1 mt-2">
                  <CustomizedDatePicker
                    values={startDate && new Date(startDate)}
                    // title={"Created Date from"}
                    placeholder={"Created Date From"}
                    setFormValues={(value) => handleCreatedDateFilterChange("created_date_from", value)}
                    containerSx={quotationDatePickerSx}
                  />
                  <CustomizedDatePicker
                    // title={"Created Date to"}
                    values={endDate && new Date(endDate)}
                    setFormValues={(value) => handleCreatedDateFilterChange("created_date_to", value)}
                    placeholder={"Created Date To"}
                    minDate={startDate && new Date(startDate)}
                    containerSx={quotationDatePickerSx}
                  />
                </div>

              </Grid>
              {moreFilters()}
            </>}
          </Grid>
          <Box sx={{ display: isMobile ? "none" : "block" }}>
            <Table
              header={headers}
              data={quotation?.data || []}
              pageSize={Number(length)}
              onTableRowClick={openQuotationDetails}
            />
          </Box>

          {isMobile && <Box>
            <div className="d-flex justify-content-between align-items-center p-1 pb-2">
              <div className="d-flex align-items-center text-semibold font-size-16">{quotation?.total || 0} Listings</div>
              <ButtonBase style={{ borderRadius: '100%' }} onClick={() => navigate('/quotations/create')}>
                <Icon icon={'ri:add-circle-fill'} style={{ height: 28, width: 28 }} />
              </ButtonBase>
            </div>
            <Grid container>
              {moreFilters()}
            </Grid>
            {quotation?.data?.length > 0 ? quotation.data.map((item) => (
              <Box
                key={item.id}
                onClick={() => openQuotationDetails(item)}
                sx={{
                  py: 2,
                  borderBottom: "1px solid #E2E2E2",
                  cursor: "pointer",
                }}
              >
                <Box sx={{ display: "flex", justifyContent: "space-between", gap: 1 }}>
                  <Box>
                    <Typography fontSize={14} fontWeight={500} color="#071A3A">
                      {item.customer_name}
                    </Typography>
                    <Typography fontSize={13} color="#8B9094">
                      {item.customer_phone}
                    </Typography>
                  </Box>
                  {actionButtons(item)}
                </Box>
                <Box mt={1.25}>
                  <Typography fontSize={14} fontWeight={500} color="#071A3A">
                    {item.vehicle}
                  </Typography>
                  <Typography fontSize={13} color="#8B9094">
                    {item.register_number} {item.bike_advert_type ? "•" : ""}{" "}
                    <Box component="span" color="#F79009" fontWeight={500}>
                      {item.bike_advert_type ? item.bike_advert_type.charAt(0).toUpperCase() + item.bike_advert_type.slice(1) : ""}
                    </Box>
                  </Typography>
                </Box>
                <Grid container spacing={1.25} mt={1.25}>
                  <Grid item xs={6}>
                    <div className="subheader-2 font-size-12">Loan Amount</div>
                    <div>{money(item.loan_amount)}</div>
                  </Grid>
                  <Grid item xs={6} textAlign="right">
                    <div className="subheader-2 font-size-12">Selling Price</div>
                    <div>{money(item.total_price)}</div>
                  </Grid>
                  <Grid item xs={12}>
                    <div className="subheader-2 font-size-12">Monthly / Term</div>
                    <div>
                      {money(item.monthly_instalment)}
                      <span className="subheader-2">/mth</span>
                    </div>
                    <div className="subheader-2 font-size-12">{item.loan_term} months - {Number(item.interest_rate || 0).toFixed(2)}%</div>
                  </Grid>

                  <Grid item xs={12}>
                    <div className="subheader-2 font-size-12">Remarks</div>
                    <div>{item.remarks || "-"}</div>
                  </Grid>
                  <Grid item xs={12}>
                    <div className="subheader-2 font-size-12">Created by</div>
                    <div>{item.creator_name || "-"}</div>
                    <div className="subheader-2 font-size-12">
                      {item.created_at ? moment(item.created_at, "YYYY-MM-DD HH:mm:ss").format("DD MMM YYYY, hh:mm A") : "-"}
                    </div>
                  </Grid>
                </Grid>
              </Box>
            )) : (
              <Box textAlign="center" py={4}>
                <Typography color="#8B9094">No quotations found</Typography>
              </Box>
            )}
          </Box>}

          <Box mt="auto" pt={3}>
            <TablePageControl
              length={length}
              setLength={setLength}
              page={page}
              setPage={setPage}
              totalPage={quotation?.last_page || 1}
            />
          </Box>
        </Box>

        <AppDialog
          open={Boolean(selectedQuotation)}
          close={() => {
            if (sendLoading) return;
            setSelectedQuotation(null);
            setSendingId(null);
            setSendDetailsLoading(false);
            setSendMySelfCopy(true);
          }}
          isMobile={window.innerWidth <= 768}
          title={sendMethod === "email" ? "Send PDF via email" : "Send PDF via WhatsApp"}
          width="820px"
          fullWidth
          hideCloseIcon={false}
          cancelButton={true}
          positiveTitle={
            <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
              <Icon
                icon={sendMethod === "email" ? "solar:plain-2-linear" : "ri:whatsapp-line"}
                width={16}
              />
              <span>{sendLoading ? "Sending..." : sendMethod === "email" ? "Send as PDF" : "Send via WhatsApp"}</span>
            </span>
          }
          positivePress={handleSendQuotation}
          disabled={
            sendMethod === "email"
              ? !recipientEmail.trim() || sendDetailsLoading || sendLoading
              : !selectedQuotation?.customer_phone || sendDetailsLoading || sendLoading
          }
          positiveButtonStyle={{
            color: "white",
            borderRadius: "20px",
            backgroundColor: sendMethod === "whatsapp" ? "#25D366" : "#1D1B1B",
            border: `1px solid ${sendMethod === "whatsapp" ? "#25D366" : "#1D1B1B"}`,
            paddingInline: 20,
          }}
          contentSx={{ pb: 1 }}
        >
          <Typography fontSize={14} color="#808588" mb={2.5}>
            Choose what to include before sending to {selectedQuotation?.customer_name}.
          </Typography>

          <Typography fontSize={14} fontWeight={600} mb={1.5}>
            Recipient
          </Typography>
          <Stack spacing={1.5} mb={2.75}>
            <Stack direction={{ xs: "column", sm: "row" }} justifyContent={{ xs: "flex-start", sm: "space-between" }} gap={1}>
              <Typography fontSize={14} color="#808588" fontWeight={{ xs: 600, sm: 400 }}>Customer</Typography>
              <Typography fontSize={14} color="#808588">
                {selectedQuotation?.customer_name || "-"}
              </Typography>
            </Stack>
            {sendMethod === "email" ? (
              <div>
                <Stack direction={{ xs: "column", sm: "row" }} justifyContent={{ xs: "flex-start", sm: "space-between" }} alignItems={{ xs: "auto", sm: "center" }} gap={1}>
                  <Typography fontSize={14} color="#808588" fontWeight={{ xs: 600, sm: 400 }}>Email Address</Typography>
                  <div>
                    <CustomTextField
                      placeholder="Enter email address"
                      values={recipientEmail}
                      onChange={(value) => {
                        setRecipientEmail(value);
                        if (recipientEmailError) dispatch(resetQuotationActionState());
                      }}
                      error={recipientEmailErrorMessage}
                      typePw="email"
                      height={40}
                      width={window?.innerWidth > 600 ? "350px" : "100%"}
                      showTitle
                      marginTop={0}
                      borderRadius={2}
                    />
                  </div>

                </Stack>
                <div>
                  <CheckBox
                    label={'Send myself a copy'}
                    values={sendMySelfCopy}
                    onChange={(e) => setSendMySelfCopy(e.target.checked)}
                    fontSize={"14px"}
                    color={"#808588"}
                  />
                </div>

              </div>

            ) : (
              <Stack direction="row" justifyContent="space-between" gap={1}>
                <Typography fontSize={14} color="#808588">WhatsApp number</Typography>
                <Typography fontSize={14} color="#808588">
                  {selectedQuotation?.customer_phone || "-"}
                </Typography>
              </Stack>
            )}

          </Stack>

          <Typography fontSize={14} fontWeight={600} mb={1.25}>
            What to include
          </Typography>
          <Grid container spacing={1.5} mb={2.75}>
            {[
              {
                id: "summary",
                name: "Quotation summary only",
                description:
                  "Shows monthly instalment, loan amount, term, and grand total. Clean and concise for customer review.",
              },
              {
                id: "full_schedule",
                name: "Full instalment table",
                description:
                  "Includes the year-by-year breakdown with interest, monthly payments, and last instalment for each loan duration option.",
              },
            ].map((option) => (
              <Grid item md={6} xs={12} key={option.id}>
                <Box
                  onClick={() => setPdfContent(option.id)}
                  sx={{
                    minHeight: 112,
                    p: 2,
                    border: `1px solid ${pdfContent === option.id ? "#1D1B1B" : "#E4E7E9"}`,
                    borderRadius: "10px",
                    backgroundColor: pdfContent === option.id ? "#F7F7F7" : "#FFFFFF",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Grid container spacing={1} alignItems="center">
                    <Grid item xs={10}>
                      <Typography fontSize={14} fontWeight={500} mb={0.5}>
                        {option.name}
                      </Typography>
                      <Typography fontSize={14} lineHeight={1.5} color="#808588">
                        {option.description}
                      </Typography>
                    </Grid>
                    <Grid item xs={2} display="flex" justifyContent="flex-end">
                      <FormControlLabel
                        value={option.id}
                        checked={pdfContent === option.id}
                        onChange={() => setPdfContent(option.id)}
                        control={
                          <Radio
                            size="small"
                            sx={{ "&.Mui-checked": { color: "#1D1B1B" } }}
                          />
                        }
                        label=""
                        sx={{ m: 0 }}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            ))}
          </Grid>

          <Typography fontSize={14} fontWeight={600} mb={1.5}>
            Preview
          </Typography>
          <Stack spacing={1.6} pb={pdfContent === "full_schedule" ? 2.5 : 1}>
            {sendDetailsLoading ? (
              <Typography fontSize={14} color="#808588">Loading quotation details...</Typography>
            ) : (
              <>
                {[
                  ["Selling Price", money(sendPricing.total_price)],
                  ["Loan amount", money(sendPricing.loan_amount)],
                  ["Loan term", `${sendPricing.loan_term || 0} months`],
                  ["Interest rate", `${Number(sendPricing.interest_rate || 0).toFixed(2)}% p.a.`],
                  ["Est Monthly instalment", money(sendPricing.monthly_instalment)],
                ].map(([label, value]) => (
                  <Stack key={label} direction="row" justifyContent="space-between" gap={2}>
                    <Typography fontSize={14} color="#808588">{label}</Typography>
                    <Typography
                      fontSize={14}
                      color={label === "Monthly instalment" ? "#ED1A3D" : "#808588"}
                      fontWeight={label === "Monthly instalment" ? 600 : 400}
                    >
                      {value}
                    </Typography>
                  </Stack>
                ))}
              </>
            )}
          </Stack>

          {pdfContent === "full_schedule" && (
            <TableContainer sx={{ mb: 1, overflowX: "auto" }}>
              <MuiTable size="small" aria-label="Full instalment preview">
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#F5F5F5" }}>
                    {[
                      "Year",
                      "Interest ($)",
                      "Monthly Instalment ($)",
                      "Last Instalment ($)",
                    ].map((heading, index) => (
                      <TableCell
                        key={heading}
                        align={index === 0 ? "left" : "right"}
                        sx={{ color: "#747B80", fontSize: 12, py: 1.2 }}
                      >
                        {heading}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {instalmentPreview.map((row) => (
                    <TableRow
                      key={row.year}
                      sx={{
                        backgroundColor:
                          row.year === Math.round((sendPricing.loan_term || 0) / 12)
                            ? "#F6F0E4"
                            : "transparent",
                      }}
                    >
                      <TableCell sx={{ fontSize: 13 }}>{row.year}</TableCell>
                      <TableCell align="right" sx={{ fontSize: 13 }}>
                        {Number(row.interest || 0).toLocaleString("en-SG", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </TableCell>
                      <TableCell align="right" sx={{ fontSize: 13 }}>
                        {Number(row.monthly_instalment || 0).toLocaleString("en-SG", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </TableCell>
                      <TableCell align="right" sx={{ fontSize: 13 }}>
                        {Number(row.last_instalment || 0).toLocaleString("en-SG", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </MuiTable>
            </TableContainer>
          )}
        </AppDialog>

        <EditQuotation
          formObj={editQuotation}
          open={editOpen}
          close={() => {
            setEditOpen(false);
            setEditQuotation(null);
          }}
          onSubmit={(response) => {
            setEditOpen(false);
            setEditQuotation(null);
            setNotification({
              open: true,
              type: "success",
              msg: response?.message || "Quotation updated successfully.",
            });
            initData();
          }}
          makeList={makeList}
          modelList={modelList}
          advertListing={advertListing}
          leftSideBarType={leftSideBarType}
        />
        <Notification
          notification={notification}
          setNotification={setNotification}
          errors={quotationError?.errors}
        />

        <QuotationDetailsDialog
          open={Boolean(detailsQuotation)}
          close={() => setDetailsQuotation(null)}
          quotation={detailsQuotation}
          onDelete={() => {
            setDeleteQuotation(detailsQuotation);
            setDetailsQuotation(null);
          }}
          onEdit={() => {
            setEditQuotation(detailsQuotation);
            setEditOpen(true);
            setDetailsQuotation(null);
          }}
        />
        <DeleteModal
          open={Boolean(deleteQuotation)}
          close={() => {
            if (!deleteLoading) setDeleteQuotation(null);
          }}
          submit={handleDeleteQuotation}
          disabled={deleteLoading}
          positiveTitle={deleteLoading ? "Deleting..." : "Delete"}
          title="Delete Quotation"
          width="420px"
          message={
            <div>
              <div className="mb-3">
                Are you sure you want to delete this quotation?
              </div>
              <div className="text-semibold mb-2">Once deleted:</div>
              <div className="subheader-2 d-flex align-items-start">
                <span style={{ marginRight: 8 }}>•</span>
                <span>
                  The quotation for {deleteQuotation?.customer_name || deleteQuotation?.customer || "this customer"}
                  will be permanently removed and cannot be undone.
                </span>
              </div>
            </div>
          }
        />
      </Container>
    </div >
  );
};

const mapStateToProps = ({ Advert, Quotation, General, Layout, Login }) => {
  return {
    quotation: Quotation?.quotationListing?.data,
    quotationInd: Quotation?.quotationListing,
    quotationDetails: Quotation?.quotationDetails,
    quotationDeleteResponse: Quotation?.quotationDelete,
    quotationEmail: Quotation?.quotationEmail,
    quotationWhatsapp: Quotation?.quotationWhatsapp,
    quotationError: Quotation?.error,
    makeList: General.bike_makes || [],
    modelList: General.bike_models || [],
    advertListing: Advert.advertListing,
    leftSideBarType: Layout.leftSideBarType,
    isDirectSeller: Login?.verifyAdmin?.user?.data?.profile?.selected_dealer_id ? false : true,

    quotationFilters: Quotation?.quotationFilters?.data,


  };
};

export default connect(mapStateToProps)(Quotations);
